'use client';
import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';
import { StyledPillSelector, StyledPillButton } from './styles.js';

const useThemeVariant = variant => {
  const theme = useTheme();
  const variants = {
    dark: {
      textColor: theme.colors.text.secondary,
      selectedTextColor: theme.colors.text.lightest,
      fillColor: theme.transparent,
      selectedFillColor: theme.colors.background.dark,
      outlineColor: theme.colors.border.dark,
      focusOutlineColor: theme.colors.border.dark,
    },
    light: {
      textColor: theme.colors.text.secondary,
      selectedTextColor: theme.colors.background.dark,
      fillColor: theme.transparent,
      selectedFillColor: theme.colors.background.lightest,
      outlineColor: theme.colors.border.dark,
      focusOutlineColor: theme.colors.background.dark,
    },
    primary: {
      textColor: theme.colors.text.primary,
      selectedTextColor: theme.colors.text.lightest,
      fillColor: theme.transparent,
      selectedFillColor: theme.colors.text.primary,
      outlineColor: theme.colors.text.primary,
      focusOutlineColor: theme.colors.text.primary,
    },
  };
  return variants[variant];
};

export const PillSelector = ({ choices, selected, onClick, variant }) => {
  const {
    textColor,
    selectedTextColor,
    fillColor,
    selectedFillColor,
    outlineColor,
    focusOutlineColor,
  } = useThemeVariant(variant);

  return (
    <StyledPillSelector>
      {choices.map(choice => (
        <StyledPillButton
          key={choice.value}
          $textColor={choice.value === selected ? selectedTextColor : textColor}
          $bgColor={choice.value === selected ? selectedFillColor : fillColor}
          $outlineColor={outlineColor}
          $focusOutlineColor={focusOutlineColor}
          onClick={() => onClick(choice.value)}
        >
          {choice.label}
        </StyledPillButton>
      ))}
    </StyledPillSelector>
  );
};

PillSelector.displayName = 'PillSelector';

PillSelector.propTypes = {
  choices: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  selected: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(['light', 'dark', 'primary']).isRequired,
};
